import React, { useEffect, useState } from 'react';
import moment from 'moment';

import axios from 'axios';
import configData from '../Config';

function AdminAccountants({ state, setState }) {
    const [accountants, setAccountants] = useState([]);
    const [search, setSearch] = useState('');

    const [refresh, setRefresh] = useState(false);
    const [result, setResult] = useState(null);

    const cancelButton = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const editButton = (accountant) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditAccountant accountant={accountant} />, modaltype: 'small', modaltitle: 'Edit Accountant' }));
    }

    const viewButton = (accountant) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewAccountant accountant={accountant} />, modaltype: 'small', modaltitle: 'View Accountant' }));
    }

    useEffect(() => {
        console.log('Trying to get accountants');

        const timeout = setTimeout(() => {
            const data = {
                search: search,
                offset: 0,
                limit: 10
            };

            axios.post(configData.CONTROLLERURL + configData.ADMINGETACCOUNTANTS, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Get accountants data received');
                console.log(res.data);
                if (res.data instanceof Array) {
                    setAccountants(res.data)
                }
            }).catch((error) => {
                console.error('Error fetching accountants:', error);
            });
        }, 500);

        return () => clearTimeout(timeout);
    }, [search, refresh]);

    function EditAccountant({ user }) {
        const [id, setId] = useState('');
        const [email, setEmail] = useState('');
        const [status, setStatus] = useState('');
        const [username, setUsername] = useState('');
        const [newpassword, setNewpassword] = useState('');

        useEffect(() => {
            setId(user.id);
            setEmail(user.email);
            setStatus(user.status);
            setUsername(user.name);
        }, [user]);

        const updateUser = (id, email, username, status) => {
            console.log('Trying to update user');

            setResult(null);

            const data = {
                id: id,
                email: email,
                username: username,
                status: status
            }

            axios.post(configData.CONTROLLERURL + configData.ADMINUPDATEUSER, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update user data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        setRefresh(!refresh)
                        cancelButton();
                    }
                    else {
                        setResult(res.data.data);
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            })
        }

        const updatePassword = (id, newpassword) => {
            console.log('Trying to update user password');

            setResult(null);

            const data = {
                id: id,
                newpassword: newpassword,
            }

            axios.post(configData.CONTROLLERURL + configData.ADMINUPDATEUSERPASSWORD, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update user password data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        cancelButton();
                    }
                    else {
                        setResult(res.data.data);
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch(() => {
                setResult('Error');
            })
        }

        return (
            <div className='modal'>
                <div className='modal_content'>
                    <div className='modal_scrollable'>
                        <div className='modal_row'>
                            <div className='modal_rowsection'>
                                <input
                                    className='modal_input'
                                    type="text"
                                    placeholder="Name"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='modal_row'>
                            <div className='modal_rowsection'>
                                <input
                                    className='modal_input'
                                    type="text"
                                    placeholder="Name"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='modal_row'>
                            <div className='modal_rowsection'>
                                <select className='modal_select' value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value="">Select status</option>
                                    <option value='A'>Active</option>
                                    <option value='P'>Pending</option>
                                </select>
                            </div>
                        </div>
                        <div className='modal_row'>
                            <div className='modal_rowsection'>
                                <input
                                    className='modal_input'
                                    type="text"
                                    value={newpassword}
                                    onChange={(e) => setNewpassword(e.target.value)}
                                />
                            </div>
                            <div className='modal_rowsection'>
                                <button className="modal_button" onClick={() => updatePassword(id, newpassword)}>Change Password</button>
                            </div>
                        </div>
                        <div className='modal_result'>{result && result}</div>
                        <div className="modal_buttonscontainer">
                            <button className="modal_button" onClick={() => updateUser(id, email, username, status)}>Update</button>
                            <button className="modal_button" onClick={cancelButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function ViewAccountant({ accountant }) {
        const [projects, setProjects] = useState([]);
        const [archivemode, setArchivemode] = useState(false);

        const [loading, setLoading] = useState(false);

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <button className="modal_button" onClick={() => setArchivemode(!archivemode)}>Archive</button>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='modal_body'>
            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <input
                        className='modal_input'
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <table className='modal_table'>
                        <thead><tr><th></th><th></th><th>Id</th><th>Email</th><th>Username</th><th>Last login</th><th>Status</th></tr></thead>
                        <tbody>
                            {
                                accountants.map((accountants, index) => {
                                    return (
                                        <tr key={'user' + index}>
                                            <td><div className='table_button' onClick={() => editButton(accountants)}>Edit</div></td>
                                            <td><div className='table_button' onClick={() => viewButton(accountants)}>View</div></td>
                                            <td><div>{accountants.id}</div></td>
                                            <td><div>{accountants.email}</div></td>
                                            <td><div>{accountants.name}</div></td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default AdminAccountants;
